import { useState, useContext } from "react";
import themeContext from "../../themeContext/themeContext";

import { FiMoon } from "react-icons/fi";
import { ImSun } from "react-icons/im";
import { RxHamburgerMenu } from "react-icons/rx";
import { VscChromeClose } from "react-icons/vsc";

import {
  WebsiteHeader,
  Nav,
  LogoContainer,
  NavLinksContainer,
  NavLink,
  DarkModeBtn,
  HamburgerMenu,
  Bar,
} from "./styledComponents";

function Header() {
  const { isDarkMode, onToggleDarkMode } = useContext(themeContext);

  const [isMenuActive, setToggleMenu] = useState(false);

  const onToggleMenuActive = () => {
    setToggleMenu((prevState) => !prevState);
  };

  return (
    <WebsiteHeader isDarkMode={isDarkMode}>
      <Nav>
        <LogoContainer>
          <a href="#hero" aria-label="logo">
            {isDarkMode ? (
              <span style={{ color: "blue", fontSize: "35px" }}>Achivers</span> // TEJA text for dark mode
            ) : (
              <span style={{ color: "#333F", fontSize: "35px" }}>Achivers</span> // TEJA text for light mode
            )}
          </a>
        </LogoContainer>
        <NavLinksContainer isDarkMode={isDarkMode} isMenuActive={isMenuActive}>
          <NavLink>
            <a href="#about">ABOUT</a>
          </NavLink>
          <NavLink>
            <a href="#intro">INTRO</a>
          </NavLink>
          <NavLink>
            <a href="#FAQS">FAQS</a>
          </NavLink>
          <NavLink>
            <a href="#contact">CONTACT</a>
          </NavLink>

          {/* Dark Mode Switch */}
          <DarkModeBtn
            aria-label="darkMode"
            type="button"
            isDarkMode={isDarkMode}
            onClick={onToggleDarkMode}
          >
            {isDarkMode ? <ImSun /> : <FiMoon />}
          </DarkModeBtn>
        </NavLinksContainer>
        {/* Mobile Hamburger Menu */}

        <HamburgerMenu isDarkMode={isDarkMode} onClick={onToggleMenuActive}>
          {isMenuActive && (
            <Bar>
              <VscChromeClose />
            </Bar>
          )}
          {!isMenuActive && (
            <Bar>
              <RxHamburgerMenu />
            </Bar>
          )}
        </HamburgerMenu>
      </Nav>
    </WebsiteHeader>
  );
}

export default Header;
